exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.phone-item[data-v-c9997712] {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.flag[data-v-c9997712] {\n  font-size: 1.5rem;\n  width: 32px;\n  text-align: center;\n}\n.phone-label[data-v-c9997712] {\n  flex-grow: 1;\n  text-align: left;\n  min-width: 50px;\n}\n", ""]);

// exports
